module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-1-bb58c28684dd06cca3b7bf52ca8d7268.jpg";